export const CATEGORY_SET_ID = "1";
export const CATEGORY_SET_2_ID = "2";
export const CATEGORY_SET_3_ID = "3";
export const IMAGE_ORIENTATIONS = [1, 6, 3, 8];
export const MAX_NEW_TOUCHPOINTS = 5;
export const TP_LIST_ITEM_WIDTH = 208;
export const TP_LIST_ITEM_HEIGHT = 205;
export const DEFAULT_BOARD_NAME = "Orga-Board";
export const POINT_FIELDS = new Set([
  "likePoints",
  "commentPoints",
  "profilePicturesPoints",
  "profileDetailsPoints",
  "favoriteBrandPoints",
  "touchPointsPoints",
  "optimizationPoints",
  // 'topTouchPointAwardPoints',
  // 'topTouchPointOptimizationPoints',
  "fulfilledTaskPoints",
  "quizPoints",
  "correctQuizPoints",
  "clientSurveyPoints",
  "surveyPoints",
]);

export const userRoles = {
  user: "user",
  admin: "admin",
  superadmin: "superadmin",
  auditor: "auditor",
};

export const surveyStates = {
  neverStarted: "neverStarted",
  started: "started",
  stopped: "stopped",
};

export const MEDIA_ENDPOINT = `https://d37ig0rx4dshla.cloudfront.net/${process.env.REACT_APP_ENVIRONMENT}/`;
export const ATTACHMENT_ENDPOINT = `https://d37ig0rx4dshla.cloudfront.net/touchpoint-attachments/`;
export const MEDIA_ENDPOINT_RESIZED = `https://d37ig0rx4dshla.cloudfront.net/images/${process.env.REACT_APP_ENVIRONMENT}/`;
export const CSS_ENDPOINT = `https://css-overrides.s3.eu-central-1.amazonaws.com/${process.env.REACT_APP_ENVIRONMENT}/`;
export const surveyTypeEnum = {
  regular: "regular",
  ordered: "ordered",
  labelCloud: "labelCloud",
  likert: "likert",
};
export const quizTypeEnum = {
  regular: "regular",
  image2: "image2",
  image4: "image4",
  swipe: "swipe",
};

export const primaryColor = "#0FB4BC";
export const altColor = "#0FB4BC";
export const secondaryColor = "#EA4967";
export const primaryTextColor = "#3A3A3A";
export const primaryTextColorShade = "#9D9D9D";
export const primaryTextColorOppositeShade = "#000000";
export const secondaryTextColorOppositeShade = "#FFFFFF";
export const bgColorOppositeShade = "#FFFFFF";

export const imageExtWhiteList = ["image/jpg", "image/gif", "image/png", "image/eps", "image/jpeg"];

export const wheelData = [
  { option: "10", value: 10 },
  { option: "100 💰", value: 100 },
  { option: "25", value: 25 },
  { option: "50", value: 50 },
  { option: "10", value: 10 },
  { option: "🤕", value: 0 },
  { option: "25", value: 25 },
  { option: "50", value: 50 },
];
